import { authGuard } from '@auth0/auth0-vue';
import { RouteNames } from '@/data/routes';

import MainLayout from '@/components/layouts/MainLayout.vue';

import PaymentRepaymentsPage from '@/pages/payments/PaymentRepaymentsPage.vue';
import { createRoutes } from '@/utils/router-helper';

export default createRoutes({
  path: '/payments',
  name: RouteNames.PAY_VENDORS.INDEX,
  component: MainLayout,
  beforeEnter: authGuard,
  meta: {
    requiresAuth: true,
    displayNav: true,
  },
  children: [
    {
      path: 'history',
      name: RouteNames.PAYMENTS.INDEX,
      component: PaymentRepaymentsPage,
      props: () => ({
        repaymentsType: 'history',
      }),
    },
    {
      path: 'upcoming',
      alias: '/pay-vendors/upcoming-payments',
      name: RouteNames.PAYMENTS.UPCOMING,
      component: PaymentRepaymentsPage,
      props: () => ({
        repaymentsType: 'upcoming',
      }),
    },
  ],
});
